import { NoResultComponent } from '@/app/components/shared/no-result/no-result.component';
import { SkeletonStandingsComponent } from '@/app/components/shared/skeleton/skeleton-details-standings/skeleton-details-standings-component';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { StandingsTableComponent } from '../../components';
import { MatchStandingsService } from '../../services';

@Component({
  selector: 'app-standing',
  standalone: true,
  imports: [
    StandingsTableComponent,
    NoResultComponent,

    SkeletonStandingsComponent,
  ],
  templateUrl: './standing.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StandingComponent {
  tsExternalCompetitionId = input.required<string>();
  matchId = input.required<string>();
  homeId = input.required<string>();
  awayId = input.required<string>();

  matchStandingsService = inject(MatchStandingsService);

  ngOnInit() {
    this.matchStandingsService.getMatchStandings(this.matchId());
  }
}
